import styled from 'styled-components';

interface InfoPaperAreaProps {
  justifyContent?: 'flex-start' | 'space-between';
  flexDirection?: 'column' | 'row' | 'row-reverse' | 'column-reverse';
}

export const LeftInfoPaperArea = styled.div<InfoPaperAreaProps>`
  display: flex;
  align-content: space-around;
  flex-direction: ${(props) => props.flexDirection || 'column'};
  justify-content: space-between;
`;

export const RightInfoPaperArea = styled.div<InfoPaperAreaProps>`
  display: flex;
  align-content: space-around;
  flex-direction: ${(props) => props.flexDirection || 'column'};
  ${(props) =>
    props.justifyContent === 'flex-start'
      ? 'justify-content: flex-start; & > div { margin-bottom: 1rem; }'
      : 'justify-content: space-between; & > div { margin-bottom: 2rem; }'};
`;
